import script from "./TopNoticeBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./TopNoticeBanner.vue?vue&type=script&setup=true&lang=js"

import "./TopNoticeBanner.vue?vue&type=style&index=0&id=3d060981&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d060981"]])

export default __exports__